import React, {useEffect, useState} from "react";
import '../assets/css/color-picker.css';

const ColorPicker = ({color, handleColorChange}) => {
    const [currentColor, setCurrentColor] = useState('#fff');

    const handleChange = (e) => {
        setCurrentColor(e.target.value);
        handleColorChange(e.target.value);
    };

    useEffect(() => {
        if (color) {
            setCurrentColor(color);
        }
    }, [currentColor, color]);

    return (
        <>
            <label className="color-selector">
                <span className="circle" style={{ background: currentColor }}></span>
                <span>{currentColor}
                    <input
                        type="color" 
                        value={currentColor} 
                        onChange={handleChange} 
                        className="hidden"
                    />
                </span>
            </label>
        </>
    )
};

export default ColorPicker;
